import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, timeout } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';

// Mobil PRE-LOGIN intézmény/IdP-választó. A decentralizált modellben minden intézmény külön deploy =
// külön Keycloak IdP, ezért belépés ELŐTT ki kell választani, melyikhez lépünk be. A választott
// intézmény baseDomain-jét eltároljuk (AuthService.chooseInstitution) és újratöltünk – az index.html
// az újratöltés után a window.env.baseDomain-be teszi, így az environment a helyes IdP/API-hoz derivál.
@Component({
  selector: 'app-intezmeny-belepo',
  templateUrl: './intezmeny-belepo.component.html',
  styleUrls: ['./intezmeny-belepo.component.scss'],
})
export class IntezmenyBelepoComponent implements OnInit {
  intezmenyek: any[] = [];
  betolt = true;
  hiba = '';
  keziDomain = '';

  constructor(private http: HttpClient, private auth: AuthService, private router: Router) {}

  async ngOnInit() {
    // Ha már be van jelentkezve, ne ragadjunk a választón.
    try { if (this.auth.isLoggedIn) { this.router.navigateByUrl('/'); return; } } catch { /* ignore */ }
    await this.betoltLista();
  }

  async betoltLista() {
    this.betolt = true; this.hiba = '';
    try {
      const base = String((environment as any).idpDirectory || '').replace(/\/+$/, '');
      //  Időkorlát: lógó hálózaton (elnyelt csomagok) a kérés percekig is várna, és addig
      //  csak a töltés látszana. 10 mp után a hibaüzenet és a kézi domain-mező jön.
      this.intezmenyek = (await firstValueFrom(this.http.get<any[]>(base + '/institutions').pipe(timeout(10000)))) || [];
    } catch (e) {
      this.hiba = 'Nem sikerült betölteni az intézmények listáját. Ellenőrizd az internetkapcsolatot, vagy add meg kézzel az intézmény domainjét.';
      this.intezmenyek = [];
    }
    this.betolt = false;
  }

  valaszt(inst: any) {
    if (!inst?.baseDomain) return;
    this.auth.chooseInstitution(inst);
    // Újratöltés: az index.html a választott baseDomain-t a window.env-be teszi (az Angular bundle
    // kiértékelése ELŐTT) → az OAuth már a helyes intézmény IdP-jéhez megy.
    window.location.href = '/';
  }

  valasztKezi() {
    const d = String(this.keziDomain || '').trim().replace(/^https?:\/\//, '').replace(/\/+$/, '');
    if (!d) return;
    this.valaszt({ id: d, name: d, baseDomain: d });
  }
}
